import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ASSESSMENT_MAX_CHARS } from '../utils/constants.utils';
import { CharactersLimit } from './CharactersLimit';

interface IProps {
  onAnswer: (answer: string) => void;
  maxChars?: number;
  antiCheat?: boolean;
}

export const AssessmentFreeText:React.FC<IProps> = ({ onAnswer, maxChars = DEFAULT_ASSESSMENT_MAX_CHARS, antiCheat = false }) => {
  const { t } = useTranslation();
  const [answerInput, setAnswerInput] = useState<string>('');

  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement> | React.DragEvent<HTMLTextAreaElement>) => {
    if (antiCheat) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    const valToSet = maxChars && val.length > maxChars ? val.substring(0, maxChars) : val;
    setAnswerInput(valToSet);
    onAnswer(valToSet);
  };
  return (
    <div className="myinterview-widget-assessment__free-text">
      <textarea
        className="myinterview-widget-assessment__input myinterview-widget-scroll-indicator"
        value={answerInput}
        placeholder={t('assessment.free_text.input_placeholder')}
        onPaste={handlePaste}
        onDrop={handlePaste}
        onChange={handleChange}
      />
      {!!maxChars && <CharactersLimit currentLength={answerInput.length} maxLength={maxChars} />}
    </div>
  );
};
